/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlaystationX = createReactComponent("outline", "playstation-x", "IconPlaystationX", [["path", { "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z", "key": "svg-0" }], ["path", { "d": "M8.5 8.5l7 7", "key": "svg-1" }], ["path", { "d": "M8.5 15.5l7 -7", "key": "svg-2" }]]);

export { IconPlaystationX as default };
//# sourceMappingURL=IconPlaystationX.mjs.map
